import { createContext, useContext } from 'react'

export const OrganizationContext = createContext({
    organization: undefined,
    organizationConfigs: undefined,
    program: undefined,
    setOrganization: (organization: any) => {
        console.error('Context not implemented')
    },
    setOrganizationConfigs: (organizationConfigs: any) => {
        console.error('Context not implemented')
    },
    setProgram: (program: any) => {
        console.error('Context not implemented')
    },
})
OrganizationContext.displayName = 'OrganizationContext'

export const useOrganization = () => useContext(OrganizationContext)
